module.exports = __webpack_public_path__ + "static/media/online-visit-image-banner.1c96a710.png";